module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_home-761f8ccaf48198cf5a8d3d7f5cf1d264.svg";